import { z } from 'zod';

export const lostBothSchema = z.object({
  fullName: z.string().min(2, 'Full name is required'),
  idNumber: z.string().min(6, 'ID or passport number is required'),
  employerOrFirm: z.string().min(2, 'Employer or law firm name is required'),
  lastKnownEmail: z.string().email('Enter a valid email address'),
  mothersMaidenName: z.string().min(2, 'Required for identity verification'),
  yearOfBirth: z
    .string()
    .regex(/^\d{4}$/, 'Enter a 4-digit year')
    .refine((v) => {
      const n = parseInt(v, 10);
      return n >= 1920 && n <= 2010;
    }, 'Enter a plausible year of birth'),
  additionalContext: z.string().optional(),
});

export type LostBothFormValues = z.infer<typeof lostBothSchema>;
